import React from "react";
interface IInputEmail {
    placeholder?: string;
    pattern?: string;
    name?: string;
    value?: string;
    displayError?: boolean;
    required?: boolean;
    className?: string;
    disabled?: boolean;
    onChange: (value: string) => void;
    onPressEnterKey: () => void;
}

class InputEmail extends React.Component<React.PropsWithChildren<IInputEmail>> {
    public render (): JSX.Element {
        return (
            <input
                className={
                    "inputComponent__input inputComponent__input--email" +
                    (this.props.displayError ? " inputComponent__input--error " : " ") +
                    this.props.className
                }
                autoCapitalize="off"
                pattern={this.props.pattern}
                type="email"
                placeholder={this.props.placeholder}
                value={this.props.value}
                required={this.props.required}
                name={this.props.name}
                id={this.props.name}
                disabled={this.props.disabled}
                onChange={(e) => this.props.onChange(e.currentTarget.value)}
                onKeyDown={(e) => e.keyCode === 13 && this.props.onPressEnterKey()}
            />
        );
    }
}

export default InputEmail;
